<template>
  <section class="forHome timeline">
    <Grid class="gridForTimeline forHome">
      <div class="grid-column x8">
        <img class="wood" :src="require('../assets/wood.svg')" />
      </div>
      <div class="timetable grid-column x4">
        <div class="content txt">
          <h2>Timeline</h2>

          <ul>
            <li>
              <strong>
                2020
                <span>-</span>Today
              </strong>
              <br />Freelance consultant for strategic design implementation<br />
            </li>
            <li>
              <strong>
                2017
                <span>-</span>2020
              </strong>
              <br />Head of IxD / Strategic design leader <br />at Fielmann AG
            </li>
            <li>
              <strong>
                2013
                <span>-</span>2017
              </strong>
              <br />Head of IxD at Fielmann Ventures
            </li>
            <li>
              <strong>
                2012
                <span>-</span>2013
              </strong>
              <br />Techevangelist at Piccobello
            </li>
            <li>
              <strong>
                2010
                <span>-</span>2013
              </strong>
              <br />Co-Founder and CTO of lwl
            </li>
            <li>
              <strong>
                2004
                <span>-</span>2010
              </strong>
              <br />Co-Founder and partner of DIGIPETS
            </li>
            <li>
              <strong>
                2001
                <span>-</span>2004
              </strong>
              <br />Designer and frontend developer at Propeller
            </li>
          </ul>
        </div>
      </div>
    </Grid>
  </section>
</template>
<script>
import Grid from "./Grid.vue";
export default {
  name: "Timeline",
  components: {
    Grid
  }
};
</script>
<style scoped>
.timeline {
  background-color: var(--GREY);
}

.gridForTimeline {
  flex-wrap: nowrap;
  align-items: flex-start;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
}

.timeline ul {
  background-color: var(--GREY);
  outline: 10px solid var(--BLACK);
  padding: 20px;
  z-index: 20;
  position: relative;
}

.timeline strong {
  font-weight: bold;
  display: inline-block;
  margin-bottom: 5px;
  line-height: inherit;
}

.timeline strong span {
  display: inline-block;
  width: 45px;
  text-indent: -100px;
  overflow: hidden;
  position: relative;
}

.timeline strong span::after {
  content: " ";
  position: absolute;
  height: 3.1px;
  left: calc(50% - 16px);
  top: calc(50% + 8px);
  background-color: var(--BLACK);
  width: 30px;
}

.wood {
  width: calc(100% - 200px);
  height: auto;
  display: block;
  padding-top: calc(var(--LINE-HEIGHT) * 5);
}

.timetable {
  position: absolute;
  top: 0;
  left: 0;
}

@media only screen and (max-width: 576px) {
  .timeline {
    padding-top: calc(var(--LINE-HEIGHT) * 1);
    padding-bottom: calc(var(--LINE-HEIGHT) * 4);
    min-height: calc(100 * var(--vh) - var(--LINE-HEIGHT));
  }

  section.forHome,
  .grid.forHome {
    min-height: calc(var(--vh) * 120);
  }

  .timetable {
    position: relative;
  }

  .timetable h2 {
    margin-bottom: calc(var(--LINE-HEIGHT));
  }

  .timeline strong {
    font-size: 20px;
  }
  .timeline strong span::after {
    left: calc(50% - 17px);
    top: calc(50% + 4px);
  }

  .wood {
    position: absolute;
    height: auto;
    width: 860px;
    margin-left: calc(860px / -2);
    left: 50%;
    top: calc(var(--vh) * 50);
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .timeline {
    padding-top: calc(var(--LINE-HEIGHT) * 1);
    padding-bottom: calc(var(--LINE-HEIGHT) * 4);
    min-height: calc(100 * var(--vh) - var(--LINE-HEIGHT));
  }
  .timetable {
    position: relative;
  }

  .timetable h2 {
    margin-bottom: calc(var(--LINE-HEIGHT));
  }
  .wood {
    position: absolute;
    height: auto;
    width: 1000px;
    margin-left: calc(1000px / -2);
    left: 50%;
    top: calc(var(--LINE-HEIGHT) * 9);
  }
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .wood {
    width: calc(100% - 120px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Section.Timeline.vue